module.exports = __webpack_public_path__ + "img/244.5b0f23ce.png";